import styled from 'styled-components';

// Lightbox is always dark regardless of theme mode. All colors are hardcoded.

export const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.85);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10000;
	padding: 10px 20px;
	box-sizing: border-box;
`;

export const ContentContainer = styled.div`
	position: relative;
	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Image = styled.img`
	max-width: 100%;
	max-height: 90vh;
	object-fit: contain;
	border-radius: 8px;
`;

export const CloseButton = styled.button`
	position: absolute;
	top: 16px;
	right: 16px;
	background: rgba(255, 255, 255, 0.08);
	border: none;
	padding: 8px;
	border-radius: 50%;
	color: rgba(255, 255, 255, 0.9);
	transition: all 0.2s ease-in-out;
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background-color: rgba(255, 255, 255, 0.15);
	}
`;

export const NavButton = styled.button<{ $side: 'left' | 'right' }>`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	${({ $side }) => ($side === 'left' ? 'left: 16px;' : 'right: 16px;')}
	background: rgba(255, 255, 255, 0.08);
	border: none;
	padding: 12px;
	border-radius: 50%;
	color: rgba(255, 255, 255, 0.9);
	transition: all 0.2s ease-in-out;
	z-index: 10;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		background-color: rgba(255, 255, 255, 0.15);
	}
`;

export const LoadingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 200px;
	min-height: 200px;
`;

export const TextPreview = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 700px;
	max-height: 92vh;
	background: rgba(20, 20, 20, 0.95);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 8px;
	overflow: hidden;
`;

export const TextHeader = styled.div`
	padding: 14px 16px 10px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.08);
	flex-shrink: 0;
`;

export const TextFilename = styled.div`
	font-size: 15px;
	font-weight: 700;
	color: rgba(255, 255, 255, 0.9);
`;

export const TextMeta = styled.div`
	margin-top: 4px;
	font-size: 12px;
	color: rgba(255, 255, 255, 0.4);
`;

export const TextContent = styled.pre`
	margin: 0;
	padding: 16px;
	overflow-y: auto;
	white-space: pre-wrap;
	word-break: break-word;
	font-family: 'Menlo', 'Monaco', 'Courier New', monospace;
	font-size: 13px;
	line-height: 1.5;
	color: rgba(255, 255, 255, 0.85);
	user-select: text;
	scrollbar-width: thin;
	scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
`;

export const PdfPreview = styled.iframe`
	width: 80vw;
	height: 85vh;
	border: none;
	border-radius: 8px;
	background: white;
`;
